import { render } from "./UAFlag.vue?vue&type=template&id=7ca906d4"
import script from "./UAFlag.vue?vue&type=script&lang=js"
export * from "./UAFlag.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__